import { Service } from 'typedi';

import DataStoreHelper from '../../../../Modules/Utils/DataStoreHelper';
import { TokenType } from '../../../models/enums/Consts';
import { IRegistrationAutoLoginModel } from '../models';
import { AutoLoginDataBuilder } from './autologindata.builder.service';

@Service()
export class RegistrationAutoLoginDataBuilder extends AutoLoginDataBuilder<IRegistrationAutoLoginModel> {
    public Build = async (data: any): Promise<IRegistrationAutoLoginModel> => {
        const loginModel: IRegistrationAutoLoginModel = {
            AuthenticationInfo: JSON.stringify({
                TokenData: {
                    TokenType: TokenType.Regular,
                    TokenValue: decodeURIComponent(data.UserInfo),
                },
            }),
            EncryptionType: String(data?.EncryptionType ?? ''),
            SourceProductPackage: data.SourceProductPackage,
            ClientVersion: DataStoreHelper.getStoreItem('ClientVersion'),
            TargetProductPackage: DataStoreHelper.getStoreItem('ProductPackage'),
            TargetSubBrand: DataStoreHelper.getStoreItem('SubBrandId'),
        };

        this._setLoginNativeProps(loginModel);

        return loginModel;
    };
}
